import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import { getActiveUsersReports, getNewUsersReports } from "store/actions"
import { prepareDataForUsersChart } from "./utils"

const UsersChart = ({
  activeUsersReports,
  newUsersReports,
  handleRemoveWidget,
  getActiveUsersReports,
  getNewUsersReports,
}) => {
  const [rangeToggle, setRangeToggle] = useState("year")
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (activeUsersReports && newUsersReports) {
      const data = prepareDataForUsersChart(
        activeUsersReports,
        newUsersReports,
        rangeToggle
      )
      setChartData(
        rangeToggle === "day"
          ? data?.map(x => {
              const formattedDate = new Date(
                `${x?.date}:00`
              ).toLocaleTimeString([], { hour: "numeric" })
              return { ...x, date: x?.date.split(" ")[0] + " " + formattedDate }
            })
          : data
      )
    }
  }, [activeUsersReports, newUsersReports])

  useEffect(() => {
    getActiveUsersReports({ type: rangeToggle })
    getNewUsersReports({ type: rangeToggle })
  }, [rangeToggle])

  return (
    <Col xs={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h5>
                Users{" "}
                {rangeToggle === "day"
                  ? "(last 24 hours)"
                  : rangeToggle === "week"
                  ? "(last 7 days)"
                  : rangeToggle === "month"
                  ? "(last 30 days)"
                  : "(last 12 months)"}
              </h5>
            </Col>
            <Col xs="auto">
              <i
                className="bx bx-x font-size-22"
                style={{ cursor: "pointer" }}
                onClick={handleRemoveWidget}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-end mt-1">
            <Col xs="auto">
              <SaveButton
                type="button"
                color={rangeToggle === "day" ? "primary" : "secondary"}
                size="sm"
                content="Day"
                onClick={() => setRangeToggle("day")}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                color={rangeToggle === "week" ? "primary" : "secondary"}
                size="sm"
                content="Week"
                onClick={() => setRangeToggle("week")}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                color={rangeToggle === "month" ? "primary" : "secondary"}
                size="sm"
                content="Month"
                onClick={() => setRangeToggle("month")}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                color={rangeToggle === "year" ? "primary" : "secondary"}
                size="sm"
                content="Year"
                onClick={() => setRangeToggle("year")}
              />
            </Col>
          </Row>
          <Row style={{ height: "320px" }}>
            <Col>
              <ResponsiveContainer>
                <BarChart
                  data={chartData}
                  width={500}
                  height={500}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip cursor={{ fill: "rgb(220, 220, 220, 0.5)" }} />
                  <Legend />
                  <Bar
                    dataKey="active_users"
                    name="Active Users"
                    fill="#556ee6"
                  />
                  <Bar dataKey="new_users" name="New Users" fill="#ffc83d" />
                </BarChart>
              </ResponsiveContainer>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

const mapStateToProps = state => ({
  activeUsersReports: state.Analytics.activeUsersReports,
  newUsersReports: state.Analytics.newUsersReports,
})

const mapDispatchToProps = dispatch => ({
  getActiveUsersReports: values => dispatch(getActiveUsersReports(values)),
  getNewUsersReports: values => dispatch(getNewUsersReports(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersChart)
